import i18n from '~/locales/i18n';

i18n.addResourceBundle('en', 'app', {
  leadFollowUpTitle: '{{propertyType}} {{section}} in {{location}}',
  leadFollowUpDescription:
    'Because you are interested in {{propertyType}} {{section}} in {{location}}, we picked the top real estate companies in the area. Request a call and the biggest companies will reach out with the available offers.',
  leadFollowUpTopSellersTitle: 'Top Real Estate Companies',
  leadFollowUpRelatedListingsTitle: 'Related Listings',
  leadFollowUpListingsUnit: 'Listings',
  leadFollowUpRequestCall: 'Request a call',
  leadFollowUpCallRequested: 'Call requested',
});
